export default {
  "base": [
    "text-(--ui-primary) border-b border-transparent hover:border-(--ui-primary) font-medium focus-visible:outline-(--ui-primary) [&>code]:border-dashed hover:[&>code]:border-(--ui-primary) hover:[&>code]:text-(--ui-primary)",
    "transition-colors [&>code]:transition-colors"
  ]
}